/**
 * Encapsulation of the identity of the user.
 */
export default class Identity {
    constructor(tokenResponse) {
        this.account = tokenResponse.account;
        this.rawIdToken = tokenResponse.idToken;
    }

    get userId() {
        return this.account.localAccountId;
    }

    get emailAddress() {
        return this.account.username;
    }

    get name() {
        return this.account.name;
    }

    get idToken() {
        return this.rawIdToken;
    }
}
